import React, { useCallback, useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import ReviewLayout from '../Practice/PracticeReview/ReviewLayout';
import FeedbackReport from '../Practice/PracticeReview/FeedbackReport';
import { getAiClientFeedback, requestAiClientFeedback } from './myPageApi';
import { toReviewSession } from './aiClientActivity';
import '../Practice/AIClients/AIClients.css';
import './MyPage.css';

// 마이페이지 활동 이력에서 연 면담 피드백 리포트 화면. GET /api/mypage/ai-client-activity/:instanceId/feedback
export default function AiClientFeedbackPage() {
    const { instanceId } = useParams();
    const { state } = useLocation();
    const [feedback, setFeedback] = useState(undefined);
    const [error, setError] = useState('');
    const [requesting, setRequesting] = useState(false);
    const [requestError, setRequestError] = useState('');

    // 피드백 리포트를 불러와 상태에 넣는다. 아직 없으면 null.
    const load = useCallback(async () => {
        setError('');
        setFeedback(undefined);
        try {
            setFeedback(await getAiClientFeedback(instanceId));
        } catch (loadError) {
            setError(loadError.message);
        }
    }, [instanceId]);

    useEffect(() => { load(); }, [load]);

    // 리포트가 없는 면담의 피드백을 새로 요청하고, 받으면 바로 보여준다.
    async function requestReport() {
        if (requesting) return;
        setRequesting(true);
        setRequestError('');
        try {
            setFeedback(await requestAiClientFeedback(instanceId));
        } catch (failure) {
            setRequestError(failure.message);
        } finally {
            setRequesting(false);
        }
    }

    const backLink = <Link className="my-page-back-link" to="/mypage/activity">← 활동 이력으로</Link>;

    if (error || !feedback) return <div className="ai-clients-page my-page"><div className="ai-clients-wrap">
        {backLink}
        {error ? <div className="my-page-card my-page-placeholder" role="alert"><h3>피드백 리포트를 불러오지 못했습니다</h3><p>{error}</p><button type="button" className="my-page-button my-page-retry" onClick={load}>다시 시도</button></div>
            : feedback === null ? <div className="my-page-card my-page-placeholder">
                <h3>피드백 리포트가 없습니다</h3>
                <p>이 면담은 아직 종합 피드백을 받지 않았습니다. 지금 요청하면 면담 대화를 분석해 리포트를 만듭니다.</p>
                {requestError && <p className="my-page-field-error" role="alert">{requestError}</p>}
                <button type="button" className="my-page-button my-page-retry" disabled={requesting} onClick={requestReport}>{requesting ? '분석 중…' : '피드백 요청하기'}</button>
                {requesting && <p className="my-page-notice" role="status">면담을 분석하고 있습니다. 1~2분 정도 걸릴 수 있어요.</p>}
            </div>
            : <p className="my-page-notice" role="status">피드백 리포트를 불러오고 있습니다.</p>}
    </div></div>;

    // 목록에서 넘어오지 않고 주소로 바로 들어온 경우 내담자 정보 없이 리포트만 보여준다.
    return <>
        <div className="my-page-back-bar">{backLink}</div>
        <ReviewLayout feedback session={toReviewSession(state?.activity, feedback)}><FeedbackReport analysis={feedback} /></ReviewLayout>
    </>;
}
